import React from 'react';

import Head from './Head';
import Row from './Row';
import NoRegisterFound from '../../../../components/NoRegisterFound';

import { TableList, TableBody } from './styles';

const Table = ({
  data,
  head,
  pathname,
  handleReceived,
  handleUndoReceived,
}) => {
  if (!data[0]) {
    return <NoRegisterFound />;
  }

  const keys = Object.keys(data[0]);

  return (
    <TableList>
      <Head head={head} keys={keys} />
      <TableBody>
        {data.map((item, index) => (
          <Row
            item={item}
            key={String(index)}
            pathname={pathname}
            handleReceived={handleReceived}
            handleUndoReceived={handleUndoReceived}
          />
        ))}
      </TableBody>
    </TableList>
  );
};

export default Table;
